module.exports = __webpack_public_path__ + "static/img/infantry.9c4233c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/infantry.png
// module id = tJB3
// module chunks = 0